const DEMO_TASKS = [
  {
    id: 'T-20250430-001',
    title: 'Q2广告预算复盘与优化',
    type: '广告分析',
    asin: 'B08N5WRWNW',
    sku: 'SKU-AD-001',
    store: 'Store-A',
    site: 'US',
    assignee: '当前用户',
    collaborators: ['Alice', 'Bob'],
    priority: 'high',
    dueDate: '2026-05-05',
    materials: '上月广告报表、竞品关键词列表',
    files: [{ name: 'ad_report_mar.xlsx', size: '24KB', url: '#' }],
    description: '需要对Q2广告预算进行全面复盘，重点分析ACOS高于30%的campaign，并输出优化方案。',
    needLeoApproval: true,
    status: 'processing',
    createdAt: '2026-04-28T10:00:00',
    aiOutput: '已生成初步分析：共有7个campaign ACOS超标，建议暂停3个，降低竞价2个，优化关键词匹配方式2个。',
    actions: [
      { user: '当前用户', time: '2026-04-28 10:30', content: '开始处理任务，下载广告数据' },
      { user: 'Alice', time: '2026-04-29 14:20', content: '补充了竞品关键词数据' },
    ],
    approvals: [],
    logs: [
      { time: '2026-04-28 10:00', content: '任务创建', type: 'create', user: '当前用户' },
      { time: '2026-04-28 10:05', content: '状态变更为：处理中', type: 'status', user: '当前用户' },
    ],
    reviewResult: '',
    comments: [
      { user: 'Alice', time: '2026-04-29 14:25', content: '已补充竞品关键词，请查收附件。', replies: [] },
    ],
    tags: ['广告', 'Q2'],
    riskLevel: 'medium',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-002',
    title: '美国站主图A+素材更新',
    type: '图片需求生成',
    asin: 'B09JK17LNL',
    sku: 'SKU-IMG-042',
    store: 'Store-B',
    site: 'US',
    assignee: 'Bob',
    collaborators: ['Carol'],
    priority: 'urgent',
    dueDate: '2026-04-25',
    materials: '产品白底图、竞品参考链接、卖点文案',
    files: [{ name: 'product_shots.zip', size: '156MB', url: '#' }],
    description: '需要更新主图和A+页面素材，突出新升级功能，参考竞品页面已附链接。',
    needLeoApproval: true,
    status: 'review',
    createdAt: '2026-04-20T09:00:00',
    aiOutput: '已生成9张主图和28张A+素材初稿，风格为高端科技感。',
    actions: [
      { user: 'Bob', time: '2026-04-21 11:00', content: '上传产品素材' },
      { user: 'Carol', time: '2026-04-22 16:30', content: '确认卖点文案' },
    ],
    approvals: [],
    logs: [
      { time: '2026-04-20 09:00', content: '任务创建', type: 'create', user: 'Bob' },
      { time: '2026-04-21 11:00', content: '状态变更为：处理中', type: 'status', user: 'Bob' },
      { time: '2026-04-24 18:00', content: '状态变更为：待审核', type: 'status', user: 'Bob' },
    ],
    reviewResult: '',
    comments: [
      { user: 'Carol', time: '2026-04-22 16:35', content: '卖点文案已确认，建议强调续航提升30%。', replies: [{ user: 'Bob', time: '2026-04-22 17:00', content: '收到，已调整。' }] },
    ],
    tags: ['主图', 'A+'],
    riskLevel: 'high',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-003',
    title: '德国站Listing标题与五点优化',
    type: 'Listing优化',
    asin: 'B08N5M7S6K',
    sku: 'SKU-DE-103',
    store: 'Store-C',
    site: 'DE',
    assignee: 'Alice',
    collaborators: ['当前用户'],
    priority: 'medium',
    dueDate: '2026-05-10',
    materials: '现有Listing内容、关键词搜索报告',
    files: [],
    description: '针对德国站进行本地化Listing优化，需符合德语表达习惯并嵌入高搜索量关键词。',
    needLeoApproval: false,
    status: 'pending',
    createdAt: '2026-04-30T08:00:00',
    aiOutput: '',
    actions: [],
    approvals: [],
    logs: [
      { time: '2026-04-30 08:00', content: '任务创建', type: 'create', user: 'Alice' },
    ],
    reviewResult: '',
    comments: [],
    tags: ['Listing', 'DE'],
    riskLevel: 'low',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-004',
    title: 'FBA库存预警与补货计划',
    type: '库存/货件处理',
    asin: 'B07XYZ1234',
    sku: 'SKU-INV-88',
    store: 'Store-A',
    site: 'US',
    assignee: '当前用户',
    collaborators: [],
    priority: 'high',
    dueDate: '2026-05-02',
    materials: '库存报表、销售预测表',
    files: [{ name: 'inventory_week18.csv', size: '8KB', url: '#' }],
    description: '多个SKU库存低于30天覆盖，需要制定补货计划并创建货件。',
    needLeoApproval: false,
    status: 'pending',
    createdAt: '2026-04-29T16:00:00',
    aiOutput: '',
    actions: [],
    approvals: [],
    logs: [
      { time: '2026-04-29 16:00', content: '任务创建', type: 'create', user: '当前用户' },
    ],
    reviewResult: '',
    comments: [],
    tags: ['库存', '补货'],
    riskLevel: 'medium',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-005',
    title: '知识产权投诉申诉处理',
    type: 'Case/申诉处理',
    asin: 'B09ABC5678',
    sku: 'SKU-APP-09',
    store: 'Store-D',
    site: 'UK',
    assignee: 'David',
    collaborators: ['Leo'],
    priority: 'urgent',
    dueDate: '2026-04-28',
    materials: '投诉通知邮件、产品专利检索报告、供应商授权书',
    files: [{ name: 'complaint_letter.pdf', size: '320KB', url: '#' }, { name: 'patent_search.pdf', size: '1.2MB', url: '#' }],
    description: '收到知识产权投诉，需准备POA申诉材料并在48小时内提交。',
    needLeoApproval: true,
    status: 'rejected',
    createdAt: '2026-04-25T10:00:00',
    aiOutput: '已生成POA初稿，包含根本原因、已采取措施、预防措施三部分。',
    actions: [
      { user: 'David', time: '2026-04-25 11:00', content: '开始撰写POA' },
      { user: 'David', time: '2026-04-26 15:00', content: '提交初稿待审核' },
    ],
    approvals: [
      { user: 'Leo', time: '2026-04-27 09:00', decision: 'reject', comment: '根本原因分析不够深入，需要补充供应商质检流程改进细节。', round: 1 },
    ],
    logs: [
      { time: '2026-04-25 10:00', content: '任务创建', type: 'create', user: 'David' },
      { time: '2026-04-25 11:00', content: '状态变更为：处理中', type: 'status', user: 'David' },
      { time: '2026-04-26 15:00', content: '状态变更为：待审核', type: 'status', user: 'David' },
      { time: '2026-04-27 09:00', content: 'Leo 驳回，状态变更为：已驳回', type: 'approve', user: 'Leo' },
    ],
    reviewResult: '需补充供应商质检流程和内部审核机制。',
    comments: [
      { user: 'Leo', time: '2026-04-27 09:05', content: '请重点补充供应商质检流程改进细节，这是亚马逊审核的核心关注点。', replies: [{ user: 'David', time: '2026-04-27 10:00', content: '明白，我联系供应商获取质检报告后补充。' }] },
    ],
    tags: ['POA', '知识产权'],
    riskLevel: 'high',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-006',
    title: '日本站Creator红人合作方案',
    type: 'Creator红人合作',
    asin: 'B08JP12345',
    sku: 'SKU-JP-77',
    store: 'Store-E',
    site: 'JP',
    assignee: 'Eve',
    collaborators: ['当前用户', 'Carol'],
    priority: 'medium',
    dueDate: '2026-05-15',
    materials: '目标红人清单、产品样品、合作预算',
    files: [{ name: 'creator_list_jp.xlsx', size: '18KB', url: '#' }],
    description: '筛选10位日本生活类Creator，制定合作方案并寄送样品。',
    needLeoApproval: true,
    status: 'completed',
    createdAt: '2026-04-15T09:00:00',
    aiOutput: '已生成红人筛选评分表和合作话术模板。',
    actions: [
      { user: 'Eve', time: '2026-04-16 10:00', content: '筛选红人名单' },
      { user: 'Carol', time: '2026-04-18 14:00', content: '确认合作预算' },
    ],
    approvals: [
      { user: 'Leo', time: '2026-04-28 11:00', decision: 'approve', comment: '方案可行，按预算执行。', round: 1 },
    ],
    logs: [
      { time: '2026-04-15 09:00', content: '任务创建', type: 'create', user: 'Eve' },
      { time: '2026-04-16 10:00', content: '状态变更为：处理中', type: 'status', user: 'Eve' },
      { time: '2026-04-25 17:00', content: '状态变更为：待审核', type: 'status', user: 'Eve' },
      { time: '2026-04-28 11:00', content: 'Leo 通过，状态变更为：已完成', type: 'approve', user: 'Leo' },
    ],
    reviewResult: '合作方案获得批准，已进入执行阶段。',
    comments: [],
    tags: ['红人', 'JP'],
    riskLevel: 'low',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-007',
    title: 'Prime Day促销价格活动规划',
    type: '促销/价格活动',
    asin: 'B09DEF9876',
    sku: 'SKU-PD-2026',
    store: 'Store-A',
    site: 'US',
    assignee: '当前用户',
    collaborators: ['Alice'],
    priority: 'high',
    dueDate: '2026-05-20',
    materials: '历史促销数据、竞品价格监控、利润率分析',
    files: [{ name: 'prime_day_history.xlsx', size: '45KB', url: '#' }],
    description: '制定Prime Day促销策略，包括折扣力度、库存准备、广告预算分配。',
    needLeoApproval: true,
    status: 'processing',
    createdAt: '2026-04-27T11:00:00',
    aiOutput: '已分析过去3年Prime Day数据，建议重点SKU折扣15-20%，广告预算提升2倍。',
    actions: [
      { user: '当前用户', time: '2026-04-27 14:00', content: '开始数据分析' },
    ],
    approvals: [],
    logs: [
      { time: '2026-04-27 11:00', content: '任务创建', type: 'create', user: '当前用户' },
      { time: '2026-04-27 14:00', content: '状态变更为：处理中', type: 'status', user: '当前用户' },
    ],
    reviewResult: '',
    comments: [
      { user: 'Alice', time: '2026-04-28 09:00', content: '建议增加Lightning Deal的预算分配比例。', replies: [] },
    ],
    tags: ['PrimeDay', '促销'],
    riskLevel: 'medium',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-008',
    title: '店铺安全巡检 - 美国站',
    type: '店铺安全巡检',
    asin: '',
    sku: '',
    store: 'Store-A',
    site: 'US',
    assignee: '当前用户',
    collaborators: [],
    priority: 'urgent',
    dueDate: '2026-04-20',
    materials: '店铺健康度报告、绩效通知邮件',
    files: [],
    description: '定期检查店铺安全状况，处理绩效通知和潜在风险。',
    needLeoApproval: true,
    status: 'overdue',
    createdAt: '2026-04-10T08:00:00',
    aiOutput: '',
    actions: [],
    approvals: [],
    logs: [
      { time: '2026-04-10 08:00', content: '任务创建', type: 'create', user: '当前用户' },
      { time: '2026-04-10 08:05', content: '状态变更为：处理中', type: 'status', user: '当前用户' },
      { time: '2026-04-21 00:00', content: '任务已超时，状态变更为：已超时', type: 'status', user: '系统' },
    ],
    reviewResult: '',
    comments: [],
    tags: ['安全', '巡检'],
    riskLevel: 'high',
    archived: false,
    llmConfig: null,
  },
  {
    id: 'T-20250430-009',
    title: '视频需求生成 - 产品展示片',
    type: '视频需求生成',
    asin: 'B09JK17LNL',
    sku: 'SKU-VID-01',
    store: 'Store-B',
    site: 'US',
    assignee: 'Carol',
    collaborators: ['Bob'],
    priority: 'low',
    dueDate: '2026-05-30',
    materials: '产品3D模型、脚本参考、品牌指南',
    files: [{ name: 'brand_guidelines.pdf', size: '2.5MB', url: '#' }],
    description: '制作15秒产品展示视频，用于广告投放和A+页面。',
    needLeoApproval: false,
    status: 'archived',
    createdAt: '2026-03-15T10:00:00',
    aiOutput: '视频脚本已生成，分镜已设计。',
    actions: [
      { user: 'Carol', time: '2026-03-16 11:00', content: '完成脚本撰写' },
    ],
    approvals: [],
    logs: [
      { time: '2026-03-15 10:00', content: '任务创建', type: 'create', user: 'Carol' },
      { time: '2026-03-16 11:00', content: '状态变更为：处理中', type: 'status', user: 'Carol' },
      { time: '2026-04-01 15:00', content: '状态变更为：已完成', type: 'status', user: 'Carol' },
      { time: '2026-04-05 09:00', content: '任务已归档', type: 'status', user: 'Leo' },
    ],
    reviewResult: '视频质量达标，已上传至品牌旗舰店。',
    comments: [],
    tags: ['视频', '品牌'],
    riskLevel: 'low',
    archived: true,
    llmConfig: null,
  },
];

export default DEMO_TASKS;
